export default function (http) {
    return {

        query (data){
            return http.json({
                url: '/account/part/query',
                data
            });
        },
        saveInfo (data){
            return http.json({
                url: '/account/part/save',
                data
            });
        },

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/sysAccountPart.js